import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import bold from "../assets/bold.png"
import italic from "../assets/italic.png"
import gallery from "../assets/gallery.png"
import gif from "../assets/gif.png"
import emijo from "../assets/emijo.png"
import send from "../assets/swnd.png"
import location from "../assets/location.png"
import edit from "../assets/edit (2).png"
import share from "../assets/link.png"
import time from "../assets/time.png"
import del from "../assets/delete.png"
import user from "../assets/user.png"
import feed from "../assets/feed.png"
import like from "../assets/like.png"
import link from "../assets/share.png"
import dot from "../assets/dot.png"
import one from "../assets/one.png"
import two from "../assets/two.png"
import three from "../assets/three.png"
import four from "../assets/four.png"
import plus from "../assets/plus.png"

function Feed() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div mt-4  pt-2 ps-2 pe-2' style={{ backgroundColor: "white",marginTop:"85px" }}>
                    <p className='feed_heading'>My Feed</p>
                    <div className='row'>
                        <div className='col-lg-3 col-md-6 col-sm-12'>
                            <div className='post_div'>
                                <p className='post_heading'>Quick Post</p>
                                <div className='descriptiondiv'>
                                    <textarea placeholder='Description...' className='description_input mt-2' />
                                    <div className='d-flex justify-content-between align-items-end pe-2'>
                                        <div className='description_emijo'>
                                            <img className='img_description' src={bold} />
                                            <img className='img_description' src={italic} />
                                            <img className='img_description' src={gallery} />
                                            <img className='img_description' src={gif} />
                                            <img className='img_description' src={emijo} />
                                        </div>

                                        <img className='send_img' src={send} />
                                    </div>
                                </div>
                                <div className='bottom_description'>
                                    <img src={location} />
                                    <img src={edit} />
                                    <img src={share} />
                                    <img src={del} />
                                    <img src={time} />
                                </div>

                            </div>
                            <div className='create_post_div'>
                                <p className='post_heading ' style={{ textAlign: "center", paddingTop: "20px" }}>My Accounts</p>
                                <div className='user_social'>
                                    <img src={one} />
                                    <p className='user_name1'>Adam Person</p>

                                </div>
                                <div className='user_social'>
                                    <img src={two} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={three} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={four} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-8 col-md-6 col-sm-12'>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
 </>

    )
}

export default Feed